import React from "react";
import { SportsTicker } from "../helper/interfaces";
import Image from 'next/image';

export default function TickerLineup(data: {sportsTicker: SportsTicker}) {
  const sportsticker = data.sportsTicker;
  
  return (
    <React.Fragment>
      <div className="">

        <div className="kick__card">
          <div className="kick__module-margin kick__site-margin kick__site-margin--border-left kick__card--with-logo">
            <div className="ticker__header border-top">
              <div className="ticker__header__wrapper">
                <h2 className="modul__teaser__headline">Aufstellung</h2>
              </div>
            </div>
            <div className="kick__modul__item pad_0">
              {sportsticker?.lineup?.home?.team && (
                <div className="kick__lineup-text__headline">
                  <div>
                    <span>
                      {sportsticker.lineup.home.team.icon && (
                        <Image src={sportsticker.lineup.home.team.icon} alt="Logo" width="36" height="36" className="kick__flag-shadow" />
                      )}
                      <strong>{sportsticker.lineup.home.team.name}</strong>
                    </span>
                  </div>
                </div>
              )}
              {sportsticker?.lineup?.home?.lineUp && (
                <p id="homeAufstellung">{sportsticker.lineup.home.lineUp}</p>
              )}
              {sportsticker?.lineup?.home?.substitution && (
                <p id="homeEinwechslungen">
                  <strong>Einwechslungen:<br /></strong>
                  <span>{sportsticker.lineup.home.substitution.map((sub, index) => <React.Fragment key={`homeSubs-${index}`}>{sub}<br /></React.Fragment>)}<br /></span>
                </p>
              )}
              {sportsticker?.lineup?.home?.bench && (
                <p id="homeReservebank">
                  <strong>Reservebank:<br /></strong>
                  <span>{sportsticker?.lineup?.home?.bench}</span>
                </p>
              )}
              {sportsticker?.lineup?.home?.coach && (
                <p id="homeTrainer">
                  <strong>Trainer:<br /></strong>
                  <span>{sportsticker.lineup.home.coach}</span>
                </p>
              )}
              {sportsticker?.lineup?.away?.team && (
                <div className="kick__lineup-text__headline">
                  <div>
                    <span>
                      {sportsticker.lineup.away.team.icon && (
                        <Image src={sportsticker.lineup.away.team.icon} alt="Logo" width="36" height="36" className="kick__flag-shadow" />
                      )}
                      <strong>{sportsticker.lineup.away.team.name}</strong>
                    </span>
                  </div>
                </div>
              )}
              {sportsticker?.lineup?.away?.lineUp && (
                <p id="awayAufstellung">
                  {sportsticker.lineup.away.lineUp}
                </p>
              )}
              {sportsticker?.lineup?.away?.substitution && (
                <p id="awayEinwechslungen">
                  <strong>Einwechslungen:<br /></strong>
                  <span>{sportsticker.lineup.away.substitution.map((sub, index) => <React.Fragment key={`awaySubs-${index}`}>{sub}<br /></React.Fragment>)}<br /></span>
                </p>
              )}
              {sportsticker?.lineup?.away?.bench && (
                <p id="awayReservebank">
                  <strong>Reservebank:<br /></strong>
                  <span>{sportsticker.lineup.away.bench}</span>
                </p>
              )}
              {sportsticker?.lineup?.away?.coach && (
                <p id="awayTrainer">
                  <strong>Trainer:<br /></strong>
                  <span>{sportsticker.lineup.away.coach}</span>
                </p>
              )}
            </div>
          </div>
        </div>
               
      </div>
    </React.Fragment>
  );
}
